<template>
  <AuthPage :page="$page" type="confirmation" />
</template>

<script>
import { AuthPage } from '@/components/templates'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'AuthConfirmation',
  mixins: [PageMetaMixin],
  beetPage: 'hunt_confirmation',
  components: { AuthPage },
}
</script>
